module.exports = __webpack_public_path__ + "static/img/trafficActivitiesbg.80bd758.jpg";